import { useQuery } from '@tanstack/react-query';
import { ApiProposalRepository } from 'services/proposal/repositories/implementations/ApiProposalRepository';
import { isCrmCompositeId } from 'services/company-and-contacts/mappers';
import { QueryKeys } from 'utils/queryKeys';

import type { MigrationCompanyId } from 'services/entities/MigrationEntities';

export const useGetCompanyByIdQuery = (companyId: MigrationCompanyId | undefined | null) => {
  const isValidCompanyId = !!companyId && !isCrmCompositeId(companyId);
  return useQuery({
    queryKey: QueryKeys.getCompanyById(companyId),
    queryFn: () => (isValidCompanyId ? ApiProposalRepository.getCompanyById(companyId) : Promise.reject(new Error('invalid id'))),
    enabled: isValidCompanyId,
  });
};
